const getActiveMainFacetID = (state) => {
    const activeFilters = state.activeFilters;
    if (activeFilters.hovedfasett !== undefined) {
        return activeFilters.hovedfasett.id;
    }
    else {
        return null;
    }
};

export default getActiveMainFacetID;
